import { render, staticRenderFns } from "./AssignedUserButton.vue?vue&type=template&id=6f413ec6"
import script from "./AssignedUserButton.vue?vue&type=script&lang=js"
export * from "./AssignedUserButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports